import { useCallback } from "react"

import { useParams } from "react-router-dom"

import { useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { useExistingHorizontalSign } from "../../hooks/queries/horizontalSigning/useHorizontalSigns"

export const HorizontalSignValidator = (props) => {
    const { children } = props

    const { road, code, signId } = useParams()
    const navigate = useNavigateWithSearchParams()

    const navigateBack = useCallback(() => {
        navigate(code ? `../${road}/code/${code}` : `../${road}`)
    }, [code, navigate, road])

    const existingHorizontalSignInCache = useExistingHorizontalSign(signId, navigateBack)

    if (!existingHorizontalSignInCache) {
        return null
    }

    return children
}